<template>
  <div class="navbar">
    <div class="flex items-center justify-center py-2 lg:py-0">
      <img src="@/assets/logo.svg" class="p-[4px] w-full lg:mt-8 lg:mb-4 lg:p-[10px] lg:h-[120px]">
    </div>
    <ul class="mt-5">
      <li v-for="(item, i) in navItems" :key="i" id="item.route">
        <template v-if="item.route == '/backups'">
          <router-link :to="item.route" v-if="settings.getValue('hide_backup_page') != 'true'">
            <div
                class="navitem"
                :class="{
              'selected-navitem-bg-color': isSelectedNavItem(item.route)
            }"
            >
              <div class="navitem-icon">
                <font-awesome-icon v-if="!item.customIcon && !item.iconifyIcon" :icon="item.icon"> </font-awesome-icon>
                <Icon v-else-if="item.iconifyIcon" :icon="item.icon" width="24" height="16" />
                <span v-else-if="item.customIcon" style="width: 24px; height: 16px; position: relative">
                <i :class="item.icon" style="font-size: 26px; position: absolute; top: -5px" />
              </span>
              </div>

              <!--hide the title on mobile--->
              <div class="hidden-navitem-title">
                {{ item.title }}
              </div>
            </div>
          </router-link>
        </template>
        <template v-else-if="item.route == '/examinations'">
          <router-link :to="item.route" v-if="settings.getValue('examinations_module') == 'true'">
            <div
                class="navitem"
                :class="{
              'selected-navitem-bg-color': isSelectedNavItem(item.route)
            }"
            >
              <div class="navitem-icon">
                <font-awesome-icon v-if="!item.customIcon && !item.iconifyIcon" :icon="item.icon"> </font-awesome-icon>
                <Icon v-else-if="item.iconifyIcon" :icon="item.icon" width="24" height="16" />
                <span v-else-if="item.customIcon" style="width: 24px; height: 16px; position: relative">
                <i :class="item.icon" style="font-size: 26px; position: absolute; top: -5px" />
              </span>
              </div>

              <!--hide the title on mobile--->
              <div class="hidden-navitem-title">
                {{ item.title }}
              </div>
            </div>
          </router-link>
        </template>
        <template v-else-if="item.route == '/pets' || item.route == '/vet-services'">
          <router-link :to="item.route" v-if="settings.getValue('vet_module') == 'true'">
            <div
                class="navitem"
                :class="{
              'selected-navitem-bg-color': isSelectedNavItem(item.route)
            }"
            >
              <div class="navitem-icon">
                <font-awesome-icon v-if="!item.customIcon && !item.iconifyIcon" :icon="item.icon"> </font-awesome-icon>
                <Icon v-else-if="item.iconifyIcon" :icon="item.icon" width="24" height="16" />
                <span v-else-if="item.customIcon" style="width: 24px; height: 16px; position: relative">
                <i :class="item.icon" style="font-size: 26px; position: absolute; top: -5px" />
              </span>
              </div>

              <!--hide the title on mobile--->
              <div class="hidden-navitem-title">
                {{ item.title }}
              </div>
            </div>
          </router-link>
        </template>
        <template v-else>
          <router-link :to="item.route">
            <div
                class="navitem"
                :class="{
              'selected-navitem-bg-color': isSelectedNavItem(item.route)
            }"
            >
              <div class="navitem-icon">
                <font-awesome-icon v-if="!item.customIcon && !item.iconifyIcon" :icon="item.icon"> </font-awesome-icon>
                <Icon v-else-if="item.iconifyIcon" :icon="item.icon" width="24" height="16" />
                <span v-else-if="item.customIcon" style="width: 24px; height: 16px; position: relative">
                <i :class="item.icon" style="font-size: 26px; position: absolute; top: -5px" />
              </span>
              </div>

              <!--hide the title on mobile--->
              <div class="hidden-navitem-title">
                {{ item.title }}
              </div>
            </div>
          </router-link>
        </template>
      </li>
    </ul>

    <div class="navitem">
      <a @click.prevent="signout" href="javascript:void(0);" class="flex items-center w-full text-red-600 hover:text-white">
        <div class="navitem-icon">
          <font-awesome-icon icon="sign-out-alt"> </font-awesome-icon>
        </div>

        <!--hide the title on mobile--->
        <div class="hidden-navitem-title">
          {{ t('signOut') }}
        </div>
      </a>
    </div>
  </div>
</template>

<script lang="ts">
// libraries
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuth } from '@/plugins/auth'
import { useLoadingModal } from '@/plugins/loading-modal/loading-modal'
import { useAlertModal } from '@/plugins/alert-modal/alert-modal'
import { useRouter } from 'vue-router'
import { NavItem } from './NavItem'
import {useSettingsStore} from "@/stores/settingsStore";
import { Icon } from '@iconify/vue';

export default defineComponent({
  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          signOut: 'Sign Out'
        },
        ar: {
          signOut: 'تسجيل الخروج'
        }
      },
      useScope: 'global'
    })

    const settings = useSettingsStore();

    const navItems: NavItem[] = [
      {
        route: '/',
        icon: 'home',
        title: t('views.home.home'),
        customIcon: false
      },
      {
        route: '/sales',
        icon: 'dollar-sign',
        title: t('views.sales.sales'),
        customIcon: false
      },
      {
        route: '/inventory',
        icon: 'warehouse',
        title: t('views.inventory.inventory'),
        customIcon: false
      },
      {
        route: '/customers',
        icon: 'users',
        title: t('views.customers.customers'),
        customIcon: false
      },
      {
        route: '/pets',
        icon: 'mdi:paw',
        title: t('views.pets.pets'),
        customIcon: false,
        iconifyIcon: true
      },
      {
        route: '/vet-services',
        icon: 'mdi:stethoscope',
        title: t('views.vetServices.vetServices'),
        customIcon: false,
        iconifyIcon: true
      },
      {
        route: '/examinations',
        icon: 'icon-examination',
        title: t('views.examinations.examinations'),
        customIcon: true
      },
      {
        route: '/companies',
        icon: 'shop',
        title: t('views.companies.companies'),
        customIcon: false
      },
      {
        route: '/hr',
        icon: 'address-book',
        title: t('views.hr.hr'),
        customIcon: false
      },
      {
        route: '/accounting',
        icon: 'calculator',
        title: t('views.accounting.accounting'),
        customIcon: false
      },
      {
        route: "/reports",
        icon: "flag",
        title: t("views.reports.reports"),
        customIcon: false,
      },
      {
        route: '/backups',
        icon: 'hdd',
        title: t('views.backups.backups'),
        customIcon: false
      },
      {
        route: '/settings',
        icon: 'cogs',
        title: t('views.settings.settings'),
        customIcon: false
      }
    ]

    const router = useRouter()

    const isSelectedNavItem = function (parentRoute: string) {
      const currentRoute = router.currentRoute.value.fullPath

      return parentRoute === '/'
        ? currentRoute === parentRoute
        : currentRoute.startsWith(parentRoute)
    }

    const signout = async () => {
      const { show, hide } = useLoadingModal()
      const { showDanger } = useAlertModal()
      try {
        const { userLogout } = useAuth()
        show()
        router.replace('/login')
        await userLogout()
      } catch (error: any) {
        showDanger({
          title: error.title,
          body: error.body
        })
      } finally {
        hide()
      }
    }

    return {
      navItems,
      isSelectedNavItem,
      t,
      signout,
      settings
    }
  },
  components: {
    Icon
  }
})
</script>

<style scoped>
.navbar {
  background: var(--secondary-bg-color);
  padding: 10px;
  @apply top-0 sticky shadow-xl;
  min-height: 100vh;
  max-height: 100vh;
  overflow-y: auto;
}

.navitem {
  margin: 5px;
  @apply flex items-center cursor-pointer transition duration-100 ease-in-out transform;
}

.navitem:hover {
  @apply -translate-y-1;
  background: var(--primary-hover-bg-color);
  color: var(--primary-hover-text-color);
}

@screen lg {
  .navitem {
    border-radius: 10px;
    @apply justify-start;
  }
}

.selected-navitem-bg-color {
  background: var(--primary-bg-color);
  color: var(--primary-text-color);
  @extend .primary;
}

.navitem-icon {
  @apply grid m-2 w-5 justify-center flex-shrink-0;
}

@screen lg {
  .navitem-icon {
    @apply m-4 w-6;
  }
}

.hidden-navitem-title {
  @apply hidden;
}

@screen lg {
  .hidden-navitem-title {
    @apply contents;
  }
}
</style>
